import { render, staticRenderFns } from "./tenderModal.vue?vue&type=template&id=49491504&"
import script from "./tenderModal.vue?vue&type=script&lang=js&"
export * from "./tenderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports